export default "/images/skip-forward.svg?6e9c5bcb7b118dfc54e5918feedd955a";